angular.module('am4').filter('organizationName', function(orgFacService) {
    return function(orgId) {
        // Filters are sync. Get the value synchronously

        if (orgFacService.getOrganizationsDictionary().$$state.status !== 1) {
            throw new Error('Facility dictionary had no time to resolve!');
        }

        return orgFacService.getOrganizationsDictionary().$$state.value[orgId];
    };
});



// WEBPACK FOOTER //
// ./src/app/filters/organizationName.js